import {DomainEvent} from './DomainEvent';
import type {EntityExportRequest} from './EntityExportRequest';

export interface UserExportRequest extends EntityExportRequest {
  /** Can be specified to include deleted and blocked user (to be able to clean up). Defaults to `false`. */
  readonly includeInactive?: boolean;
}

/**
 * This event can be fired to indicate that a services requires user profiles.
 * Another service that is eligible to provide this info will put batches of the requested entity into
 * the specified S3 {@see UserExportRequest.targetBucket} using
 * the {@see UserExportRequest.transactionId} as prefix (sub-folder).
 */
export class UserExportRequested extends DomainEvent<UserExportRequest> {}
